module.exports = __webpack_public_path__ + "img/graph_employees.ed94e782.png";